import omit from 'lodash.omit';
import React, { HTMLAttributes } from 'react';

interface IAriaNodeProps {
  createRef: () => React.RefObject<any>;
  tagName: string;
}

export class AriaNode extends React.Component<IAriaNodeProps & HTMLAttributes<any>> {
  render() {
    const passedProps = omit(this.props, ['tagName', 'createRef']);

    return React.createElement(
      this.props.tagName,
      {
        tabIndex: 0,
        ref: this.props.createRef(),
        className: this.props.className,
        ...passedProps,
      },
      this.props.children,
    );
  }
}
